export enum DomainErrorCode {
  EmailInvalid = 0,
  InvalidStatus = 1,
  DomainInUse = 2,
  EmailMismatch = 3,
  EmailDomainMismatch = 4,
  VerificationExpired = 5,
  DomainBlocked = 6,
}
